import React from 'react';
import { ArrowRight } from 'lucide-react';
export function BrandStorySection() {
  return <section id="brand-story" className="bg-white pt-[60px] pb-[20px] md:pt-[80px] md:pb-[30px] lg:pt-[120px] lg:pb-[40px] px-6 relative overflow-hidden" data-id="element-12">
      {/* Decorative background watermark */}
      <span className="absolute right-[-2%] top-1/2 -translate-y-1/2 text-[180px] md:text-[260px] lg:text-[340px] font-optima text-charcoal/[0.05] leading-none select-none pointer-events-none" aria-hidden="true" data-id="element-13">
        1839
      </span>

      <div className="max-w-[1000px] mx-auto" data-id="element-14">
        {/* Label */}
        <span className="block text-label text-center mb-12 md:mb-16" data-id="element-15">
          Our Story
        </span>

        {/* Pull Quote with gold lines */}
        <div className="flex flex-col items-center mb-14 md:mb-20" data-id="element-16">
          {/* Gold line above */}
          <div className="w-12 h-[2px] bg-gold mb-8" data-id="element-17"></div>

          <p className="text-[28px] md:text-[36px] leading-[1.3] font-optima text-charcoal text-center max-w-[800px]" data-id="element-18">
            The story of Glenlofty is etched into the ancient soils of the
            Pyrenees.
          </p>

          {/* Gold line below */}
          <div className="w-12 h-[2px] bg-gold mt-8" data-id="element-19"></div>
        </div>

        {/* Full paragraphs in narrower column, left-aligned */}
        <div className="max-w-[700px] mx-auto" data-id="element-20">
          <div className="space-y-6 text-body text-charcoal text-left" data-id="element-21">
            <p data-id="element-22">
              The story of Glenlofty is etched into the ancient soils of the
              Pyrenees. Our land's agricultural heritage dates back to 1839, a
              legacy of pioneering spirit that we honor in our approach to
              viticulture. When the first vines were planted in 1995, it was
              with a clear vision: to create a vineyard that could rival the
              great cool-climate sites of the world. The estate's unique
              terroir, with its granitic sands and cool, continental climate,
              proved to be the perfect canvas.
            </p>
            <p data-id="element-23">
              Today, Glenlofty Estate is recognized as a 4-star Halliday winery,
              a mark of our unwavering commitment to excellence. We believe that
              great wine is not made, but grown. It is born in the vineyard,
              nurtured by the hands of our dedicated team, and guided into the
              bottle with minimal intervention. Our story is one of passion,
              patience, and a profound respect for the land we are privileged to
              call home.
            </p>
          </div>

          {/* Learn more link, left-aligned to match paragraphs */}
          <div className="mt-10" data-id="element-24">
            <a href="#" className="inline-flex items-center text-gold hover:underline underline-offset-4 transition-all group" data-id="element-25">
              <span className="uppercase tracking-wide-label text-sm font-semibold mr-2" data-id="element-26">
                Learn more about our vineyard
              </span>
              <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-27" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}